export function Footer() {
  return (
    <div className="app__footer">
      <p className="footer__text">Irina Korotkaya &mdash; 2026</p>
    </div>
  );
}
